module.exports = __webpack_public_path__ + "static/sidbibby-icon-476b8c67933b88ad59d185281a4bd48b.svg";